import { render, staticRenderFns } from "./BankToBankForm.vue?vue&type=template&id=24f00a06"
import script from "./BankToBankForm.vue?vue&type=script&lang=js"
export * from "./BankToBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports